export const managers: string[] = [
  '강민정',
  '권익재',
  '김유경',
  '윤언식',
  '박민호',
  '황예슬',
  '차진영',
  '박정영',
  '장유빈',
  '이슬비',
];
